import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Alert, Button, Snackbar } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslationsList } from "../../services/Dynamo/query";
import { useLoader } from "../../services/providers/LoaderProvider";
import { TableTranslations } from "../../components/TableTranslations";

export default function Translations() {
  const navigate = useNavigate();
  const { isLoading, items, refetch } = useTranslationsList();
  const { setLoading } = useLoader("Translations");
  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);
  const [showNotificationSuccess, setShowNotificationSuccess] = useState<boolean>(false)

  const onDelete = useCallback(() => {
    refetch()
    setShowNotificationSuccess(true)
    setTimeout(() => {
      setShowNotificationSuccess(false)
    }, 2000)
  }, [refetch])
  return (
    <div className="container mx-auto">
      <>
        <div className="flex justify-between items-center my-5">
          <h1 className="text-3xl">List of Translation</h1>
          <Button
            variant="contained"
            onClick={() => navigate("/translations/new")}
            className="buttons-style"
          >
            <AddCircleIcon className="icon-button" />
            <span className="w-full">add translation</span>
          </Button>
        </div>
        <TableTranslations onDelete={onDelete} isLoading={isLoading} translations={items || []} />
      </>
      {showNotificationSuccess &&
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={true}
          message="Operation carried out successfully"
        >
          <Alert sx={{ color: "white", backgroundColor: "#1D4EBB" }} severity="info">
            Operation carried out successfully
          </Alert>

        </Snackbar>
      }
    </div>
  );
}
